import * as React from 'react';
import { Tag } from '@beehive/components';
import PropTypes from 'prop-types';

export interface HeaderProps {
  prefixCls: string;
}

class Header extends React.Component<HeaderProps, any> {

  public static contextTypes = {
    detail: PropTypes.object,
  };

  public render() {
    const { detail } = this.context;
    const { prefixCls } = this.props;

    if (!detail) {
      return null;
    }
    const { id, name, human_state_name, l1_category_name, state } = detail;
    const className = `${prefixCls}-header`;

    return (
      <div className={className}>
        <div className={`${className}-subject`}>
          <span>{`#${id}`}</span>
          <span>{name}</span>
        </div>
        <div className={`${className}-tags`} >
          {l1_category_name ? <Tag text={l1_category_name} colorOpposite isElliptical/> : null}
          {state === 'pending_bidding' && <Tag text={"采购流程中"} colorOpposite isElliptical/>}
          <Tag text={human_state_name} isElliptical />
        </div>
      </div>
    );
  }

}

export default Header;
